export const LOAD_START_MARK_KEY = 'PROJECT_PERMANENT_DELETE_MODAL_LOAD_START_MARK_KEY';
